import Vue from 'vue'
import Vuex from 'vuex'
import survey from './survey'
import SurveyService from '../services/survey'

Vue.use(Vuex)

const steps = {
  INTRO: 'intro',
  SURVEY: 'survey',
  THANK_YOU: 'thank_you'
}

export default new Vuex.Store({
  modules: {
    survey: survey
  },
  state: {
    steps: steps,
    currentStep: steps.INTRO,
    pendingSurveySubmit: false,
    surveys: []
  },
  actions: {
    async getSurveys (context) {
      let surveys = SurveyService.getSurveys([
        {
          hash: process.env.VUE_APP_SURVEY_1_HASH,
          text: process.env.VUE_APP_SURVEY_1_TEXT,
          survey: null
        },
        {
          hash: process.env.VUE_APP_SURVEY_2_HASH,
          text: process.env.VUE_APP_SURVEY_2_TEXT,
          survey: null
        },
        {
          hash: process.env.VUE_APP_SURVEY_3_HASH,
          text: process.env.VUE_APP_SURVEY_3_TEXT,
          survey: null
        }
      ])

      if (!surveys) {
        return
      }

      context.commit('SURVEYS_UPDATED', surveys)
    },
    async submitPendingSurvey (context) {
      context.commit('PENDING_SURVEY_SUBMITTED_UPDATED', true)
    }
  },
  mutations: {
    SURVEYS_UPDATED (state, surveys) {
      state.surveys = surveys
    },
    CURRENT_STEP_UPDATED (state, currentStep) {
      state.currentStep = currentStep
    },
    PENDING_SURVEY_SUBMITTED_UPDATED (state, pendingSurveySubmit) {
      state.pendingSurveySubmit = pendingSurveySubmit
    }
  },
  getters: {
    steps: state => state.steps,
    currentStep: state => state.currentStep,
    surveys: state => state.surveys,
    pendingSurveySubmit: state => state.pendingSurveySubmit
  }
})
